module.exports = __webpack_public_path__ + "static/img/5.dda9676.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/5.png
// module id = i7+c
// module chunks = 4